import { render, staticRenderFns } from "./ques.vue?vue&type=template&id=7944ab80&scoped=true&"
import script from "./ques.vue?vue&type=script&lang=js&"
export * from "./ques.vue?vue&type=script&lang=js&"
import style0 from "./ques.vue?vue&type=style&index=0&id=7944ab80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7944ab80",
  null
  
)

export default component.exports